export class InfoBloqueioDeCreditoDTO {
    public Filial: string;

    public PrePedido: string;

    public Status: string;

    constructor(data: any = {}) {
        this.Filial = data.Filial || data.FILIAL;
        this.PrePedido = data.PrePedido || data.PREPEDIDO;
        this.Status = data.Status || data.STATUS;
    }
}